import { useContext } from 'react';

import { GeneralDataLife } from './components';

import { QuotationInfoContext } from '../../../shared/contexts';
import { StepTwoFormContext } from './contexts/StepTwoForm';
import { QuotationStepButtons } from '../../../shared';

import { QuotationStep } from '../../../shared/interfaces';

export const StepTwo = () => {
  const { setCurrentStep } = useContext(QuotationInfoContext);
  const { stepTwoForm } = useContext(StepTwoFormContext);

  const validateForm = async () => {
    try {
      await stepTwoForm?.validateFields();

      setCurrentStep(QuotationStep.THREE);
    } catch (error) {}
  };

  return (
    <>
      <GeneralDataLife />
      <QuotationStepButtons
        label='Continuar'
        onClick={validateForm}
        onPressBackButton={() => setCurrentStep(QuotationStep.ONE)}
      />
    </>
  );
};
